"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var value_checker_1 = __importDefault(require("../validation/value_checker"));
var SalesForceContactTantoObject = /** @class */ (function () {
    function SalesForceContactTantoObject() {
    }
    SalesForceContactTantoObject.create = function (contractDocument, salesForceInfo) {
        var baseObject = {
            AccountId: salesForceInfo.corporateId,
            LastName: contractDocument.officeInfoTantosyaLastName,
            FirstName: contractDocument.officeInfoTantosyaFirstName,
            NameKana__c: contractDocument.officeInfoTantosyaKanaLastName + " " + contractDocument.officeInfoTantosyaKanaFirstName,
            Email: contractDocument.officeInfoTantosyaMail,
            RehaplanAccountIssue__c: 'true'
        };
        if (value_checker_1.default.isPresent(salesForceInfo.tantoTorihikisakiId)) {
            baseObject['Id'] = salesForceInfo.tantoTorihikisakiId;
        }
        else {
            baseObject['OwnerId'] = salesForceInfo.lastUpdateUser;
        }
        return baseObject;
    };
    return SalesForceContactTantoObject;
}());
exports.default = SalesForceContactTantoObject;



//////////////////
// WEBPACK FOOTER
// ./common/src/utils/sales_force/contact_tanto_object.ts
// module id = XZXr
// module chunks = 1